import { Box, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatCurrency } from '@/utils/helper';

export default function DonationCard({ donation }) {
  const { t, i18n } = useTranslation();
  const displayName =
    donation.isAnonymous || !donation.username ? t('common.anonymous') : donation.username;

  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 2,
        padding: 2,
        border: '1px solid #333',
        backgroundColor: '#1e1e1e',
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 600 }}>
          {displayName}
        </Typography>
        {donation.message && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ marginTop: 0.5, fontStyle: 'italic', overflowWrap: 'anywhere' }}
          >
            &ldquo;{donation.message}&rdquo;
          </Typography>
        )}
        <Typography variant="caption" sx={{ display: 'block', marginTop: 1, color: '#aaa' }}>
          {new Date(donation.createdAt).toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </Typography>
      </Box>

      <Typography
        variant="h5"
        className="text-yellow-400"
        sx={{ minWidth: 100, fontWeight: 700, textAlign: 'right' }}
      >
        {formatCurrency(donation.amount, i18n.language)}
      </Typography>
    </Paper>
  );
}

DonationCard.propTypes = {
  donation: PropTypes.shape({
    isAnonymous: PropTypes.bool.isRequired,
    username: PropTypes.string,
    message: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};
